import type { ReactNode } from 'react';

import { Backdrop } from '@/components/fx/Backdrop';
import { ScrollProgress } from '@/components/fx/ScrollProgress';
import { SiteFooter } from '@/components/SiteFooter';
import { SiteHeader } from '@/components/SiteHeader';

/**
 * Chrome shared by every redesigned page: fixed atmosphere, reading progress,
 * the sticky header and the footer. Pages supply only their <main>.
 *
 * The skip link stays in App so the legacy routes keep theirs too.
 */
export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <Backdrop />
      <ScrollProgress />
      <SiteHeader />
      {children}
      <SiteFooter />
    </>
  );
}
